import { render, staticRenderFns } from "./ReservasTable.vue?vue&type=template&id=acbcfb50&scoped=true&"
import script from "./ReservasTable.vue?vue&type=script&lang=js&"
export * from "./ReservasTable.vue?vue&type=script&lang=js&"
import style0 from "./ReservasTable.vue?vue&type=style&index=0&id=acbcfb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbcfb50",
  null
  
)

export default component.exports